export const RESET = 'EXSBDELIVERY_LIST_RESET'
export const SET_ITEMS = 'EXSBDELIVERY_LIST_SET_ITEMS'
export const SET_ERROR = 'EXSBDELIVERY_LIST_SET_ERROR'
export const SET_VIEW = 'EXSBDELIVERY_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXSBDELIVERY_LIST_TOGGLE_LOADING'
